document.addEventListener("DOMContentLoaded", () => {
  const transliterationMap = {
    // German
    ae: "ae",
    oe: "oe",
    ue: "ue",
    ss: "ss",

    // Common latin extensions / ligatures
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    å: "a",
    ă: "a",
    ą: "a",
    ā: "a",
    æ: "ae",
    ç: "c",
    ć: "c",
    č: "c",
    đ: "d",
    ď: "d",
    è: "e",
    é: "e",
    ě: "e",
    ė: "e",
    ë: "e",
    ê: "e",
    ę: "e",
    ē: "e",
    ğ: "g",
    ǵ: "g",
    ḧ: "h",
    ì: "i",
    í: "i",
    ï: "i",
    î: "i",
    į: "i",
    ī: "i",
    ł: "l",
    ḿ: "m",
    ǹ: "n",
    ń: "n",
    ň: "n",
    ñ: "n",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ø: "o",
    ō: "o",
    œ: "oe",
    ṕ: "p",
    ŕ: "r",
    ř: "r",
    ş: "s",
    ś: "s",
    š: "s",
    ș: "s",
    ť: "t",
    ț: "t",
    ù: "u",
    ú: "u",
    û: "u",
    ǘ: "u",
    ů: "u",
    ű: "u",
    ū: "u",
    ų: "u",
    ẃ: "w",
    ẍ: "x",
    ÿ: "y",
    ý: "y",
    ź: "z",
    ž: "z",
    ż: "z",
  };

  const charRegex = new RegExp(Object.keys(transliterationMap).join("|"), "g");

  window.slugify = function (value) {
    if (value == null) return "";

    let string = String(value).trim();

    // Multi-char mappings first (before generic lower/normalize path)
    string = string
      .replace(/Ä/g, "Ae")
      .replace(/Ö/g, "Oe")
      .replace(/Ü/g, "Ue")
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ẞ/g, "SS")
      .replace(/ß/g, "ss");

    string = string
      .toLowerCase()
      .replace(charRegex, (ch) => transliterationMap[ch] || ch)
      // Strip remaining accents safely (NFD fallback)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, "-and-")
      .replace(/[\s/_,:;]+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");

    return string;
  };
});
